import { FiltersState } from "../../../../reporting/states"
import { StudyPlanTargets } from "../../../machines/studyPlan/types"
import {
  PROGRAMS_WITH_STUDY_PLAN_V2,
  STUDY_PLAN_V2_SUBPAGE_TARGET_MAP
} from "./constants"

export const getStudyPlanV2CurrentTarget = (
  subpage: string
): StudyPlanTargets | null => {
  if (!subpage) {
    return null
  }

  if (subpage === "view") {
    return StudyPlanTargets.ViewRecommended
  }

  if (subpage === "edit") {
    return StudyPlanTargets.Edit
  }

  return STUDY_PLAN_V2_SUBPAGE_TARGET_MAP[subpage] || null
}

export const getFiltersWithMultipleValues = (
  filtersState: FiltersState,
  hiddenFilters?: string[]
) => {
  if (!filtersState) {
    return []
  }

  return Object.entries(filtersState)
    .filter(([key, value]) => value.length > 1 && !hiddenFilters?.includes(key))
    .map(([key]) => key)
}

export const checkStudyPlanV2Enabling = (
  program: string,
  isOldNav: boolean,
  studyPlanV2FeatureFlag: boolean
) => {
  return (
    !isOldNav &&
    PROGRAMS_WITH_STUDY_PLAN_V2.includes(program) &&
    !!studyPlanV2FeatureFlag
  )
}
